<template>
  <v-card-text class="pb-0">
    <div>
      <p class="text-h5 font-weight-bold neutral100--text">
        {{ $t('ARTWORK.EDIT.WORD.ITEM_TYPE') }}
      </p>
      <v-item-group
        :value="value"
        @change="(v) => $emit('input', v)"
        color="neutral100"
        class="ma-0"
        hide-details
        dense
        row
      >
        <v-row>
          <v-col
            v-for="type in types"
            :key="`type:${type.key}`"
            v-show="!hide.includes(type.key)"
          >
            <v-item :value="type.key" v-slot="{ active, toggle }">
              <v-card
                class="type_item_card"
                @click="!readonly && toggle()"
                :class="{ active }"
                :color="readonly ? null : 'neutral600'"
                :disabled="readonly"
              >
                <v-img :aspect-ratio="1">
                  <div class="fill-all flex-center">
                    <div class="w100p">
                      <v-img
                        max-width="33%"
                        :aspect-ratio="1"
                        :src="getImageIcon(type.key, active)"
                        class="mx-auto"
                        contain
                      ></v-img>
                      <div
                        class="text-center font-weight-bold mt-2"
                        :class="active ? 'primary--text' : 'neutral200--text'"
                      >
                        {{ $t(type.name) }}
                      </div>
                    </div>
                  </div>
                </v-img>
              </v-card>
            </v-item>
          </v-col>
        </v-row>
      </v-item-group>
    </div>
  </v-card-text>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    hide: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      types: [
        {
          key: 'image',
          name: 'ARTWORK.EDIT.WORD.IMAGE'
        },
        {
          key: 'video',
          name: 'ARTWORK.EDIT.WORD.VIDEO'
        },
        {
          key: 'sound',
          name: 'ARTWORK.EDIT.WORD.SOUND'
        },
        {
          key: '3dmodel',
          name: 'ARTWORK.EDIT.WORD.3D_MODEL'
        },
        {
          key: 'website',
          name: 'ARTWORK.EDIT.WORD.WEBPAGE'
        }
      ]
    };
  },

  methods: {
    getImageIcon(name, active) {
      return require(`@/assets/icons/${name}${active ? '_active' : ''}.svg`);
    }
  }
};
</script>

<style lang="scss" scoped>
.type_item_card.active {
  border-width: 2px !important;
  border-style: solid !important;
  border-color: $primary !important;
}
</style>